import Config from "../Config";
import {Row} from 'reactstrap';
import {useEffect, useState} from "react";
import _ from "../Trans";
import token from "../AuthToken";
import Currency from './Currency';
import {LessButton, MoreButton} from "./MoreLessButtons";
import {faLocationDot} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


const MAX_CHARACTERS_IN_USERNAME = 25;
const MINILEAGUE_BROKER = Config.MINILEAGUE_BROKER;
const MINILEAGUE_GOALS_AND_STOPS = Config.MINILEAGUE_GOALS_AND_STOPS;
const MOBILE_MAX_WIDTH = Config.MOBILE_MAX_WIDTH;

const goalsText = _('Goals');
const stopsText = _('Stops');
const assistsText = _('Assists');
const blocksText = _('Blocks');
const stealsText = _('Steals');

export default function SquadRanking({weekly=false, squad, name, points, position, totalTeams, display, tournament}) {
  const [ranking, setData] = useState([]);
  const [nextUrl, setNextUrl] = useState();
  const [previousUrl, setPreviousUrl] = useState();
  const [offset, setOffset] = useState(0);
  const [blocked, setBlocked] = useState(false);

  const fetchRankingInfo = () => {
    let url = weekly ? Config.weeklyRankingUrl : Config.rankingUrl;
    url = url.replace("/0/", "/"+tournament+"/");
    fetchRanking(url);
  }

  const fetchRanking = function (url) {
    setBlocked(true);
    return fetch(url, {
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        }
    })
    .then((res) => res.json())
    .then((d) => {
        setNextUrl(d.next);
        setPreviousUrl(d.previous);
        setData(d.results);
    })
    .catch((e) => {
        console.error("In fetchRankingInfo: ", url, e);
        window.location.href = '/squad/';
    })
    .finally(() => setBlocked(false));
  }

    const fetchMyPosition = function() {
        if(!weekly) {
            return;
        }
        const positionOffset = getMyPositionOffset(position);
        setOffset(positionOffset)
        const url = Config.weeklyRankingUrl.replace("/0/", "/"+tournament+"/") + "?limit=10&offset="+positionOffset;
        fetchRanking(url);
    }

    const requestMore = function () {
        if(blocked) {
            return;
        }
        if (nextUrl === null) {
            return;
        }
        setOffset(offset+10);
        return fetchRanking(nextUrl)
    }

    const requestPrevious = function () {
        if(blocked) {
            return;
        }
        if (previousUrl === null) {
            return;
        }
        setOffset(offset-10);
        return fetchRanking(previousUrl)
    }

  useEffect(() => {
      let queryParameters = new URLSearchParams(window.location.search)
      let urlPosition = parseInt(queryParameters.get('position'));
      if(!isNaN(urlPosition)) {
          fetchMyPosition();
      }
      else {
          fetchRankingInfo();
      }
  }, [tournament]);   // eslint-disable-line

    useEffect(() => {
        if(weekly) {
            const queryParameters = new URLSearchParams(window.location.search)
            const urlPosition = parseInt(queryParameters.get('position'));
            if(!isNaN(urlPosition)) {
                fetchMyPosition();
            }
        }
        else {
            fetchRankingInfo();
        }
    }, []); // eslint-disable-line

    const moreLessButtonStyle = {
        paddingTop: "0px",
        paddingBottom: "0px",
        ...(blocked ? {color: "grey"} : {})
    };
  return <div style={display}>
    <Row className="mt-4">
    </Row>
      <RankingSquadHeader name={name} points={points} position={position} totalTeams={totalTeams} fetchMyPositionHandler={fetchMyPosition}
                          goals={weekly ? squad?.goals_last_week : squad?.total_goals}
                          stops={weekly ? squad?.stops_last_week : squad?.total_stops}
                          assists={weekly ? squad?.assists_last_week : squad?.total_assists}
                          blocks={weekly ? squad?.blocks_last_week : squad?.total_blocks}
                          steals={squad?.total_steals}
      />
        <Row>
        <div className="col-12 mb-5">
            <table className="table table-striped ranking-striped w-100 mt-3 most-valuable-players" id="ranking">
                <SquadInRankingTableHeader></SquadInRankingTableHeader>
                <tbody>
                <tr>
                    <td align="center" colSpan={4} style={moreLessButtonStyle}>
                        {previousUrl ? <LessButton requestPrevious={requestPrevious}/> : ""}
                    </td>
                </tr>
                {ranking.map((squad, index) => <SquadInRanking key={squad.id} squad={squad} index={index} offset={offset}/>)}
                </tbody>
                <tfoot>
                <tr>
                    <td align="center" colSpan={4} style={moreLessButtonStyle}>
                        {nextUrl ? <MoreButton requestMore={requestMore}/> : ""}
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
        </Row>
    </div>
}

function getMyPositionOffset(position) {
    try {
        const substract = position % 10 === 0 ? 10 : position % 10;
        position = position - substract;
    }
    catch(e) {
        position = 0;
    }
    return position;
}

function getTranslationForPointsType(type) {
    let pointsText = _('Points');
    if(type === MINILEAGUE_BROKER) {
        pointsText = _('Current value')
    }
    else if(type===MINILEAGUE_GOALS_AND_STOPS) {
        pointsText = _('Goals + Stops')
    }
    return pointsText;
}

function RankingSquadHeader({name, points, position, totalTeams, type=1, fetchMyPositionHandler, goals, stops, assists, blocks, steals}) {
    const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
    const teamClass = 'col-6 ' + (isMobile ? 'text-center' : '')
    const headerInfoClass = 'ranking-header-info';
    const smallText = {'fontSize': (isMobile ? '0.7rem' : '0.9rem')}
    const rankingClass = 'col-3 ' + (isMobile ? 'text-center' : 'text-right')
    const teamClassInfoClass = teamClass + ' ' + headerInfoClass;
    const rankingClassInfoClass = rankingClass + ' ' + headerInfoClass + ' link';
    const col3Center = 'col-3 text-center ';
    let pointsText = getTranslationForPointsType(type);

    const fetchMyPosition = function() {
        fetchMyPositionHandler();
    }

    return (
        <Row id="ranking-header" className="rounded pt-3">
            <div className={teamClass}>
                <small style={smallText}>{_('Team')}</small>
            </div>
            <div className={col3Center}>
                <small style={smallText}>{pointsText}</small>
            </div>
            <div className={rankingClass}>
                <small style={smallText}>{_('Ranking position')}</small>
            </div>
            <div className={teamClassInfoClass}>
                <div className={headerInfoClass}>{name}</div>
            </div>
            <div className={col3Center + headerInfoClass}>
                <div className={headerInfoClass}>
                    {type === MINILEAGUE_BROKER
                        ? <Currency value={points}></Currency>
                        : points
                    }
                </div>
            </div>
            <div className={rankingClassInfoClass} onClick={fetchMyPosition}>
                <section> <p className={headerInfoClass}>{position}º/{totalTeams}  <FontAwesomeIcon icon={faLocationDot}/></p></section>
            </div>
            <div className={'col-12'}>
                <div style={smallText} className={"d-inline mr-3"}>{goalsText}: {goals}</div>
                <div style={smallText} className={"d-inline mr-3"}>{stopsText}: {stops}</div>
                <div style={smallText} className={"d-inline mr-3"}>{assistsText}: {assists}</div>
                <div style={smallText} className={"d-inline mr-3"}>{blocksText}: {blocks}</div>
                <div style={smallText} className={"d-inline mr-3"}>{stealsText}: {steals}</div>
            </div>
        </Row>
    )
}

function SquadInRankingTableHeader({type=1}) {
    const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
    let pointsText = getTranslationForPointsType(type);

    return (
        <thead>
            <tr>
                <th scope="col" width="10%">#</th>
                {isMobile ? (
                <th scope="col" className="text-left" style={{paddingLeft: '2px'}}>{_('Team')} / {_('User')}</th>
                )
                :
                (
                <th scope="col" className="text-left" style={{paddingLeft: '2px'}} width="45%">{_('Team')}</th>
                )}
                {!isMobile && <th scope="col">{_('User')}</th>}
                <th scope="col" className="text-right" width={isMobile ? "50%" : "20%"}>{pointsText}</th>
            </tr>
        </thead>
    )
}

function SquadInRanking({squad, index, type=1, offset=0}) {
    const isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
    const styleTeamName = isMobile ? {padding: '2px'} : {paddingLeft: '2px'}
    let points = squad.latest_points
    if (type === MINILEAGUE_BROKER) {
        points = squad.current_value
    }
    else if (type === MINILEAGUE_GOALS_AND_STOPS) {
        points = squad.goals_and_stops
    }
    if(points === null || points === undefined) {
        points = 0;
    }

    const getUsernameForView = function (username) {
        return username.length > MAX_CHARACTERS_IN_USERNAME
            ? username.substring(0, MAX_CHARACTERS_IN_USERNAME) + "..."
            : username;
    }

    try {
        return <tr>
            <th scope="row">{index+1+offset}</th>
            {isMobile ? (
            <td className="font-weight-bold" style={styleTeamName}>
                <div style={{'height': '1lh', 'overflow': 'hidden'}}>
                <b>{squad.name}</b><br/>
                </div>
                <small>{getUsernameForView(squad.username)}</small>
            </td>
            )
            :
            (
            <td style={styleTeamName}>{squad.name}</td>
            )}
            {!isMobile && <td>{getUsernameForView(squad.username)}</td>}
            <td className="text-right">{type === MINILEAGUE_BROKER ? <Currency value={points}/>: points}</td>
        </tr>
    }
    catch(e) {
        return <tr><th colSpan={5}></th></tr>
    }
}

export {SquadInRanking, RankingSquadHeader, SquadInRankingTableHeader};
